import { render, staticRenderFns } from "./MatricesTable.vue?vue&type=template&id=1be46f2c&scoped=true&"
import script from "./MatricesTable.vue?vue&type=script&lang=js&"
export * from "./MatricesTable.vue?vue&type=script&lang=js&"
import style0 from "./MatricesTable.vue?vue&type=style&index=0&id=1be46f2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be46f2c",
  null
  
)

export default component.exports